import { DEFAULT_LOCALE, VALID_LOCALES } from 'constants/locale';

export const getLocaleNoDefault = (pathname: string): string => {
  const path = pathname.match(/\/([a-z]+)/g);
  return path ? path[0].replace(/\//, '') : '';
};

export const getLocale = (pathname: string): string => {
  const path = pathname.match(/\/([a-z]+)/g);
  const locale = path ? path[0].replace(/\//, '') : '';

  return VALID_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
};

export const getPathWithoutLocale = (pathname: string): string => {
  const validLocales = VALID_LOCALES.map((l) => `/${l}`);
  const regex = new RegExp(`(${validLocales.join('|')})(/|$)`);
  const locale = pathname.match(regex);
  if (locale) return pathname.replace(locale[1], '');
  return pathname;
};

export const parseQuery = <T extends Object>(url: string): T => {
  const res = url
    .replace(/[/?]/g, '')
    .split('&')
    .reduce((acc: { [a: string]: string }, curr: string) => {
      const keyVal = curr.split('=');
      if (keyVal.length === 2) acc[keyVal[0]] = keyVal[1];
      return acc;
    }, {});
  return (res as unknown) as T;
};
